export function getEquipmentTab(category: 'sample' | 'preventive' | 'cloudConnector') {
  switch (category) {
    case 'preventive': {
      return 'preventive'
    }

    case 'sample': {
      return 'samplings'
    }

    case 'cloudConnector': {
      return 'cloudConnector'
    }

    default: {
      return 'preventive'
    }
  }
}
